<template>
  <v-row v-if="$store.getters.isSettingsReady" dense  justify="center">

    <v-col v-if="showTitle" cols="12">
      <h3
          class="text-center"
          :class="{'text-h4': $vuetify.breakpoint.smAndUp}"
      >
        {{ $t('delivery.orderReview') }}
      </h3>
      <p
          class="text-center"
      >
        {{ $t('delivery.orderReviewDescription') }}
      </p>
    </v-col>


    <template v-if="!$store.getters.orderSystem.isOrderReady">
      <v-alert>La orden no esta completa</v-alert>

      <v-col cols="12" sm="8" md="8">
        <v-alert
            v-for="(message,i) in orderConfirmationErrorMessage"
            :key="i"
            type="warning"
        >
          {{ $t(message.msg, (message.params ? message.params : null)) }}
        </v-alert>
      </v-col>
    </template>

    <template v-else>

      <v-col cols="12">
        <order-review-contact @edit="$emit('editContact')"/>
      </v-col>
      <v-col cols="12">
        <order-review-location @edit="$emit('editLocation')"/>
      </v-col>
      <v-col cols="12">
        <order-review-payment @edit="$emit('editPayment')"/>
      </v-col>
      <v-col cols="12">
        <order-review-items @edit="$emit('editProducts')"></order-review-items>
      </v-col>
      <v-col cols="12">
        <order-review-total></order-review-total>
      </v-col>

      <v-col cols="12">
        <v-alert
            v-if="isTransferPayment"
            type="info" class="ma-2" prominent
        >
          {{ getTransferInfo }}
        </v-alert>
      </v-col>
      <v-col cols="12" class="text-center my-3 py-3">
            <!--REVIEW-->
            <v-btn
                v-if="btnReview"
                @click="orderReview"
                color="grey white--text"
                x-large
                class="mr-5"
            >
              <span class="font-weight-bold">
                {{ $t('delivery.orderReview') }}
              </span>
            </v-btn>
            <!--CONFIRM-->
            <v-btn
                @click="confirmOrder"
                :disabled="!$store.getters.orderSystem.isOrderReady"
                color="green white--text"
                x-large
                :loading="loading"
            >
              <span class="font-weight-bold">
                {{ getConfirmBtnText }}
              </span>

            </v-btn>
      </v-col>
    </template>

    <v-snackbar
        v-model="error"
        :timeout="10000"
        color="orange darken-2 white--text"
    >
      {{ errorMessage }}
      <template v-slot:action>
        <v-btn
            color="white"
            text
            @click="error = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>


  </v-row>

</template>

<script>

import OrderReviewContact from "@/modules/delivery/components-core/shared/OrderReview/OrderReviewContact";
import OrderReviewLocation from "@/modules/delivery/components-core/shared/OrderReview/OrderReviewLocation";
import OrderReviewItems from "@/modules/delivery/components-core/shared/OrderReview/OrderReviewItems";
import OrderReviewTotal from "@/modules/delivery/components-core/shared/OrderReview/OrderReviewTotal";
import OrderReviewPayment from "@/modules/delivery/components-core/shared/OrderReview/OrderReviewPayment";
import {BAR} from "@/modules/delivery/constants/OrderOrigin";

export default {
  name: "OrderReview",
  props: {
    btnReview: {type: Boolean, default: false},
    showDiscount: {type: Boolean, default: false},
    showTitle: {type: Boolean, default: true},
  },
  components: {
    OrderReviewTotal,
    OrderReviewItems,
    OrderReviewLocation,
    OrderReviewContact,
    OrderReviewPayment,
  },
  data() {
    return {
      loading: false,
      error: false,
      errorMessage: '',
    }
  },
  computed: {
    orderConfirmationErrorMessage() {
      let messages = []

      let orderSystem = this.$store.getters.orderSystem

      if (orderSystem.cartService.getItemsQuantity == 0) {
        messages.push({msg: 'delivery.empty.items'})
      }

      //MINIMUN PRODUCTS
      if (orderSystem.order.origin != BAR && orderSystem.cartService.getItemsQuantity < orderSystem.settings.minimunQuantity) {
        messages.push({msg: 'delivery.empty.minimunQuantity', params: {quantity: orderSystem.settings.minimunQuantity}})
      }

      //MINIMUN CATEGORY PRODUCTS
      if (orderSystem.order.origin != BAR && orderSystem.cartService.isMinimumQuantityPerCategoryReached == false) {
        messages.push({msg: 'delivery.empty.minimunCategoryQuantityNotReached'})
      }

      if (!orderSystem.order.delivery.mode) {
        messages.push({msg: 'delivery.empty.deliveryMode'})
      }

      if (!orderSystem.order.delivery.timeMode || !orderSystem.order.delivery.time) {
        messages.push({msg: 'delivery.empty.time'})
      }


      if (orderSystem.order.isDelivery && !orderSystem.order.location.address) {
        messages.push({msg: 'delivery.empty.location'})
      }

      if (
          !orderSystem.order.contact.name ||
          !orderSystem.order.contact.phone ||
          (orderSystem.order.origin != BAR && !orderSystem.order.contact.email)
      ) {
        messages.push({msg: 'delivery.empty.contact'})
      }

      if (!orderSystem.order.payment.method) {
        messages.push({msg: 'delivery.empty.paymentMethod'})
      }

      return messages
    },
    isTransferPayment() {
      return ['BANK_TRANSFER', 'MP_TRANSFER'].includes(this.$store.getters.orderSystem.order.payment.method)
    },
    getTransferInfo() {

      if (!this.$store.getters.getPaymentMethods) {
        return null
      }

      switch (this.$store.getters.orderSystem.order.payment.method) {
        case 'BANK_TRANSFER':
          return this.$store.getters.getPaymentMethods.bankTransfer.info
        case 'MP_TRANSFER':
          return this.$store.getters.getPaymentMethods.mercadoPagoTransfer.info
        default:
          return null
      }
    },

    getConfirmBtnText() {
      if (this.isTransferPayment) {
        return this.$t('delivery.orderConfirmTransfer')
      } else {
        return this.$t('delivery.orderConfirm')
      }
    }
  },
  methods: {
    orderReview() {
      this.$emit('orderReview')
    },
    confirmOrder() {
      if (this.$store.getters.orderSystem.order.identifier) {
        this.updateOrder()
      } else {
        this.createOrder()
      }
    },
    createOrder() {
      this.loading = true
      this.error = false
      this.errorMessage = ''
      this.$store.dispatch('createOrder')
          .then((order) => {
            this.$emit('orderCreated', order)
          })
          .catch(e => {
            console.error("OrderConfirmation Error", e)
            this.error = true
            this.errorMessage = e.message.replace("GraphQL error: ", "")
          })
          .finally(() => this.loading = false)
    },
    updateOrder() {
      this.loading = true
      this.error = false
      this.errorMessage = ''
      this.$store.dispatch('updateOrder')
          .then((order) => {
            this.$emit('orderUpdated', order)
          })
          .catch(e => {
            console.error("OrderConfirmation Error", e)
            this.error = true
            this.errorMessage = e.message.replace("GraphQL error: ", "")
          })
          .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
